(function () {
  'use strict';

  if (window.__clutchLoopSectionsLoaded) return;
  window.__clutchLoopSectionsLoaded = true;

  function storageGet(key) {
    try {
      return window.sessionStorage.getItem(key);
    } catch (_error) {
      return null;
    }
  }

  function storageSet(key, value) {
    try {
      window.sessionStorage.setItem(key, value);
    } catch (_error) {
      // Storage can be unavailable in strict privacy modes.
    }
  }

  function formatWithDelimiters(number, precision, thousands, decimal) {
    var value = Number(number);
    if (!Number.isFinite(value)) return '0';
    var fixed = (value / 100).toFixed(precision);
    var parts = fixed.split('.');
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, thousands);
    return parts[1] ? parts[0] + decimal + parts[1] : parts[0];
  }

  function formatMoney(cents, format) {
    var template = format || '${{amount}}';
    var match = template.match(/\{\{\s*(\w+)\s*\}\}/);
    var placeholder = match ? match[1] : 'amount';
    var value;

    switch (placeholder) {
      case 'amount_no_decimals':
        value = formatWithDelimiters(cents, 0, ',', '.');
        break;
      case 'amount_with_comma_separator':
        value = formatWithDelimiters(cents, 2, '.', ',');
        break;
      case 'amount_no_decimals_with_comma_separator':
        value = formatWithDelimiters(cents, 0, '.', ',');
        break;
      case 'amount_with_apostrophe_separator':
        value = formatWithDelimiters(cents, 2, "'", '.');
        break;
      default:
        value = formatWithDelimiters(cents, 2, ',', '.');
    }

    return match ? template.replace(match[0], value) : value;
  }

  function showToast(message, isError) {
    var toast = document.querySelector('.cl-toast');
    if (!toast) {
      toast = document.createElement('div');
      toast.className = 'cl-toast';
      toast.setAttribute('role', 'status');
      toast.setAttribute('aria-live', 'polite');
      document.body.appendChild(toast);
    }

    toast.textContent = message;
    toast.classList.toggle('is-error', Boolean(isError));
    toast.classList.add('is-visible');
    window.clearTimeout(toast._clTimer);
    toast._clTimer = window.setTimeout(function () {
      toast.classList.remove('is-visible');
    }, 3200);
  }

  function initDismissibles(root) {
    (root || document).querySelectorAll('[data-cl-dismissible]').forEach(function (element) {
      if (element.dataset.clReady === 'true') return;
      element.dataset.clReady = 'true';

      var key = element.dataset.clDismissible || '';
      if (key && storageGet('cl-dismissed-' + key)) {
        element.classList.add('is-dismissed');
      }

      var button = element.querySelector('[data-cl-dismiss]');
      if (!button) return;
      button.addEventListener('click', function () {
        element.classList.add('is-dismissed');
        if (key) storageSet('cl-dismissed-' + key, '1');
      });
    });
  }

  function setGalleryImage(gallery, src, alt) {
    var image = gallery.querySelector('[data-cl-gallery-main]');
    if (!image || !src) return;
    image.dataset.clGallerySrc = src;
    window.clearTimeout(image.clGalleryTimer);
    image.style.opacity = '0';
    image.clGalleryTimer = window.setTimeout(function () {
      image.src = src;
      image.removeAttribute('srcset');
      if (alt) image.alt = alt;
      image.style.opacity = '1';
    }, 120);
  }

  function setGalleryCaption(gallery, thumb) {
    var caption = gallery && gallery.querySelector('[data-cl-gallery-caption]');
    if (!caption) return;
    var text = thumb ? String(thumb.dataset.clCaption || '').trim() : '';
    caption.textContent = text;
    caption.style.cssText = text ? (thumb.dataset.clCaptionStyle || '') : '';
    caption.hidden = !text;
  }

  function initGalleries(root) {
    (root || document).querySelectorAll('[data-cl-gallery]').forEach(function (gallery) {
      if (gallery.dataset.clReady === 'true') return;
      gallery.dataset.clReady = 'true';

      gallery.querySelectorAll('[data-cl-thumb]').forEach(function (thumb) {
        thumb.addEventListener('click', function () {
          gallery.querySelectorAll('[data-cl-thumb]').forEach(function (item) {
            item.classList.remove('is-active');
            item.setAttribute('aria-pressed', 'false');
          });
          thumb.classList.add('is-active');
          thumb.setAttribute('aria-pressed', 'true');
          setGalleryImage(gallery, thumb.dataset.clImage, thumb.dataset.clAlt);
          setGalleryCaption(gallery, thumb);
        });
      });
    });
  }

  function initProduct(section) {
    if (section.dataset.clReady === 'true') return;
    section.dataset.clReady = 'true';

    var form = section.querySelector('[data-cl-product-form]');
    var variantsScript = section.querySelector('[data-cl-variants]');
    if (!form || !variantsScript) return;

    var variants;
    try {
      variants = JSON.parse(variantsScript.textContent);
    } catch (_error) {
      variants = [];
    }

    var optionIndex = Number(section.dataset.clColorOptionIndex);
    var moneyFormat = section.dataset.clMoneyFormat || '${{amount}}';
    var packageCards = Array.from(section.querySelectorAll('[data-cl-package]'));
    var swatches = Array.from(section.querySelectorAll('[data-cl-swatch]'));
    var addonInputs = Array.from(section.querySelectorAll('[data-cl-addon-input]'));
    var variantInput = form.querySelector('[data-cl-variant-input]');
    var submitButton = form.querySelector('[data-cl-submit]');
    var submitPrice = form.querySelector('[data-cl-submit-price]');
    var gallery = section.querySelector('[data-cl-gallery]');
    var selectedVariant = null;
    var cycleButton = gallery && gallery.querySelector('[data-cl-gallery-cycle]');
    var cycleSide = 0;

    function canCycleProduct() {
      return cycleButton && String(selectedColor() || '').trim().toLowerCase() === String(cycleButton.dataset.clCycleColor || '').trim().toLowerCase();
    }

    if (cycleButton) {
      cycleButton.addEventListener('click', function () {
        if (!canCycleProduct()) return;
        var currentImage = gallery.querySelector('[data-cl-gallery-main]');
        var currentSource = currentImage && (currentImage.dataset.clGallerySrc || currentImage.getAttribute('src'));
        var viewingSide = currentImage && (
          currentSource === cycleButton.dataset.clCycleFront ||
          currentSource === cycleButton.dataset.clCycleBack
        );
        cycleSide = viewingSide ? 1 - cycleSide : 0;
        setGalleryImage(gallery, cycleSide ? cycleButton.dataset.clCycleBack : cycleButton.dataset.clCycleFront, 'ClutchLoop ' + cycleButton.dataset.clCycleColor + (cycleSide ? ' reverse with wordmark' : ' front with logo'));
        gallery.querySelectorAll('[data-cl-thumb]').forEach(function (thumb) {
          thumb.classList.remove('is-active');
          thumb.setAttribute('aria-pressed', 'false');
        });
        setGalleryCaption(gallery, null);
      });
    }

    function showVariantGallery(color) {
      if (!gallery) return false;
      var normalizedColor = String(color || '').trim().toLowerCase();
      var thumbs = Array.from(gallery.querySelectorAll('[data-cl-thumb]'));
      var visibleThumbs = thumbs.filter(function (thumb) {
        var thumbColor = String(thumb.dataset.clGalleryColor || '').trim().toLowerCase();
        return !thumbColor || thumbColor === normalizedColor;
      }).slice(0, 5);

      thumbs.forEach(function (thumb) {
        var isVisible = visibleThumbs.indexOf(thumb) !== -1;
        thumb.hidden = !isVisible;
        thumb.tabIndex = isVisible ? 0 : -1;
        thumb.classList.remove('is-active');
        thumb.setAttribute('aria-pressed', 'false');
      });

      var firstThumb = visibleThumbs[0];
      if (!firstThumb) { setGalleryCaption(gallery, null); return false; }

      firstThumb.classList.add('is-active');
      firstThumb.setAttribute('aria-pressed', 'true');
      setGalleryImage(gallery, firstThumb.dataset.clImage, firstThumb.dataset.clAlt);
      setGalleryCaption(gallery, firstThumb);
      return true;
    }

    function selectedPackage() {
      return packageCards.find(function (card) {
        return card.classList.contains('is-selected');
      }) || packageCards[0] || null;
    }

    function selectedColor() {
      var selected = swatches.find(function (swatch) {
        return swatch.classList.contains('is-selected');
      });
      return selected ? selected.dataset.clSwatch : '';
    }

    function packageItemsFor(card, color) {
      if (!card) return [];
      return Array.from(card.querySelectorAll('[data-cl-package-item]')).map(function (item) {
        var itemVariants = [];
        try {
          itemVariants = JSON.parse(item.dataset.clItemVariants || '[]');
        } catch (_error) {
          itemVariants = [];
        }

        var itemColorIndex = Number(item.dataset.clItemColorOptionIndex);
        var matchingVariants = itemVariants.filter(function (variant) {
          if (!color || itemColorIndex < 0) return true;
          return String((variant.options || [])[itemColorIndex] || '').toLowerCase() === String(color).toLowerCase();
        });
        var resolvedVariant = matchingVariants.find(function (variant) {
          return variant.available;
        }) || null;

        var hasVariantMap = itemVariants.length > 0;
        var price = resolvedVariant ? Number(resolvedVariant.price) || 0 : Number(item.dataset.clItemPrice) || 0;
        var comparePrice = resolvedVariant
          ? Number(resolvedVariant.compare_at_price) || 0
          : Number(item.dataset.clItemComparePrice) || 0;
        return {
          id: resolvedVariant ? resolvedVariant.id : item.dataset.clItemId || '',
          quantity: Math.max(1, Math.floor(Number(item.dataset.clItemQuantity) || 1)),
          price: price,
          compare_at_price: comparePrice > price ? comparePrice : price,
          available: resolvedVariant ? true : !hasVariantMap && item.dataset.clItemAvailable === 'true'
        };
      });
    }

    function variantFor(card, color) {
      if (!card) {
        var colorCandidates = variants.filter(function (variant) {
          return !color || optionIndex < 0 || String((variant.options || [])[optionIndex] || '') === color;
        });
        return colorCandidates.find(function (variant) { return variant.available; }) || null;
      }

      var packageItems = packageItemsFor(card, color);
      if (packageItems.length) {
        if (packageItems.some(function (item) { return !item.id || !item.available; })) return null;
        return {
          id: packageItems[0].id,
          price: packageItems.reduce(function (total, item) {
            return total + (item.price * item.quantity);
          }, 0),
          compare_at_price: packageItems.reduce(function (total, item) {
            return total + (item.compare_at_price * item.quantity);
          }, 0),
          available: true,
          packageItems: packageItems.map(function (item) {
            return { id: item.id, quantity: item.quantity };
          })
        };
      }

      var bundleVariantId = card.dataset.clBundleVariantId;
      if (bundleVariantId) {
        if (card.dataset.clBundleVariantAvailable !== 'true') return null;
        return {
          id: bundleVariantId,
          price: Number(card.dataset.clBundleVariantPrice) || 0,
          compare_at_price: Number(card.dataset.clBundleVariantComparePrice) || 0,
          available: true
        };
      }

      var packageMatch = (card.dataset.clPackageMatch || '').trim().toLowerCase();
      var candidates = variants.filter(function (variant) {
        var titleMatches = !packageMatch || String(variant.title || '').toLowerCase().indexOf(packageMatch) !== -1;
        var colorMatches = !color || optionIndex < 0 || String((variant.options || [])[optionIndex] || '') === color;
        return titleMatches && colorMatches;
      });
      return candidates.find(function (variant) { return variant.available; }) || null;
    }

    function setSelectedPackage(card) {
      packageCards.forEach(function (item) {
        var selected = item === card;
        item.classList.toggle('is-selected', selected);
        var input = item.querySelector('input[type="radio"]');
        if (input) input.checked = selected;
      });
    }

    function updatePackagePrices() {
      var color = selectedColor();
      packageCards.forEach(function (card) {
        var variant = variantFor(card, color);
        var price = card.querySelector('[data-cl-package-price]');
        var unit = card.querySelector('[data-cl-unit-price]');
        var compare = card.querySelector('[data-cl-compare-price]');
        var input = card.querySelector('input[type="radio"]');
        var unitCount = Math.max(1, Number(card.dataset.clUnitCount) || 1);

        card.classList.toggle('is-unavailable', !variant);
        if (input) input.disabled = !variant;
        if (price) price.textContent = variant ? formatMoney(variant.price, moneyFormat) + ' total' : 'Unavailable';
        if (unit) {
          unit.textContent = variant
            ? formatMoney(Math.round(variant.price / unitCount), moneyFormat) + '/ea'
            : '';
        }
        if (compare) {
          var compareOverride = (card.dataset.clComparePriceOverride || '').trim();
          var compareEnabled = card.dataset.clShowCompare === 'true';
          var hasCompare = variant && compareEnabled && (
            compareOverride || Number(variant.compare_at_price) > Number(variant.price)
          );
          compare.hidden = !hasCompare;
          compare.textContent = hasCompare
            ? (compareOverride || formatMoney(variant.compare_at_price, moneyFormat))
            : '';
        }
      });

      var current = selectedPackage();
      if (current && current.classList.contains('is-unavailable')) {
        var firstAvailable = packageCards.find(function (card) {
          return !card.classList.contains('is-unavailable');
        });
        if (firstAvailable) setSelectedPackage(firstAvailable);
      }
    }

    function updateSelectedVariant() {
      var card = selectedPackage();
      selectedVariant = variantFor(card, selectedColor());

      if (variantInput) variantInput.value = selectedVariant ? selectedVariant.id : '';
      if (submitButton) submitButton.disabled = !selectedVariant;

      var galleryVariant = selectedVariant;
      if (selectedVariant && !selectedVariant.featured_image) {
        var selectedColorValue = selectedColor();
        galleryVariant = variants.find(function (variant) {
          return variant.available && (
            !selectedColorValue ||
            optionIndex < 0 ||
            String((variant.options || [])[optionIndex] || '') === selectedColorValue
          );
        }) || null;
      }

      var hasUploadedVariantGallery = showVariantGallery(selectedColor());
      if (!hasUploadedVariantGallery && galleryVariant && gallery && galleryVariant.featured_image && galleryVariant.featured_image.src) {
        gallery.querySelectorAll('[data-cl-thumb]').forEach(function (thumb) {
          thumb.classList.remove('is-active');
          thumb.setAttribute('aria-pressed', 'false');
        });
        setGalleryCaption(gallery, null);
        setGalleryImage(gallery, galleryVariant.featured_image.src, galleryVariant.featured_image.alt || '');
      }

      if (cycleButton) {
        cycleButton.disabled = !canCycleProduct();
        cycleSide = 0;
        if (!cycleButton.disabled) {
          setGalleryImage(gallery, cycleButton.dataset.clCycleFront, 'ClutchLoop ' + cycleButton.dataset.clCycleColor + ' front with logo');
        }
      }
      updateTotal();
    }

    function updateTotal() {
      var activeOfferPackage = selectedPackage();
      window.ClutchLoopOffers.update(section, activeOfferPackage && activeOfferPackage.dataset.clPackageTitle, !!selectedVariant, function (value) { return formatMoney(value, moneyFormat); });
      if (!selectedVariant) {
        if (submitPrice) submitPrice.textContent = '';
        updateSticky(0);
        return;
      }
      var total = Number(selectedVariant.price) || 0;
      addonInputs.forEach(function (input) {
        if (input.checked && !input.disabled) total += window.ClutchLoopOffers.price(section, Number(input.dataset.clAddonPrice) || 0);
      });
      if (submitPrice) submitPrice.textContent = '— ' + formatMoney(total, moneyFormat);
      updateSticky(total);
    }

    swatches.forEach(function (swatch) {
      swatch.addEventListener('click', function () {
        swatches.forEach(function (item) {
          var selected = item === swatch;
          item.classList.toggle('is-selected', selected);
          item.setAttribute('aria-pressed', selected ? 'true' : 'false');
        });
        var label = section.querySelector('[data-cl-swatch-label]');
        if (label) label.textContent = swatch.dataset.clSwatch || '';
        section.querySelectorAll('[data-cl-selected-color-label]').forEach(function (colorLabel) {
          colorLabel.textContent = swatch.dataset.clSwatch || '';
        });
        updatePackagePrices();
        updateSelectedVariant();
      });
    });

    packageCards.forEach(function (card) {
      card.addEventListener('click', function (event) {
        if (card.classList.contains('is-unavailable')) {
          event.preventDefault();
          return;
        }
        setSelectedPackage(card);
        updateSelectedVariant();
      });
    });

    addonInputs.forEach(function (input) {
      input.addEventListener('change', function () {
        var card = input.closest('[data-cl-addon]');
        if (card) card.classList.toggle('is-selected', input.checked);
        updateTotal();
      });
    });

    form.addEventListener('submit', function (event) {
      event.preventDefault();
      if (!selectedVariant) {
        showToast('Please choose an available package.', true);
        return;
      }

      var items = [];
      function addCartItem(id, quantity) {
        if (!id) return;
        var existing = items.find(function (item) { return String(item.id) === String(id); });
        if (existing) existing.quantity += quantity;
        else items.push({ id: id, quantity: quantity });
      }

      if (selectedVariant.packageItems && selectedVariant.packageItems.length) {
        selectedVariant.packageItems.forEach(function (item) {
          addCartItem(item.id, item.quantity);
        });
      } else {
        addCartItem(selectedVariant.id, 1);
      }

      addonInputs.forEach(function (input) {
        if (input.checked && input.value) addCartItem(input.value, 1);
      });

      var destination = window.ClutchLoopOffers.cartUrl(section, addonInputs.some(function (input) { return input.checked && !input.disabled; }));
      submitButton.disabled = true;
      submitButton.setAttribute('aria-busy', 'true');

      fetch(section.dataset.clCartAddUrl, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-Requested-With': 'XMLHttpRequest'
        },
        body: JSON.stringify({ items: items })
      })
        .then(function (response) {
          return response.json().then(function (data) {
            if (!response.ok) throw new Error(data.description || data.message || 'Could not add to cart.');
            return data;
          });
        })
        .then(function (data) {
          window.location.assign(destination);
        })
        .catch(function (error) {
          showToast(error.message || 'Could not add to cart.', true);
        })
        .finally(function () {
          submitButton.disabled = false;
          submitButton.removeAttribute('aria-busy');
        });
    });

    var sticky = section.querySelector('[data-cl-sticky]');
    var stickyButton = sticky ? sticky.querySelector('[data-cl-sticky-submit]') : null;
    var stickyPackage = section.querySelector('[data-cl-sticky-package]');
    var stickyPrice = section.querySelector('[data-cl-sticky-price]');

    function updateSticky(total) {
      if (!sticky) return;

      var activePackage = selectedPackage();
      var packageKey = activePackage ? activePackage.dataset.clPackageKey || '' : '';
      if (stickyPackage) {
        Array.prototype.forEach.call(stickyPackage.options, function (option) {
          var card = packageCards.find(function (packageCard) {
            return packageCard.dataset.clPackageKey === option.value;
          });
          option.disabled = Boolean(card && card.classList.contains('is-unavailable'));
        });
        if (packageKey) stickyPackage.value = packageKey;
      }

      if (stickyPrice) stickyPrice.textContent = total ? formatMoney(total, moneyFormat) : '';
    }

    if (stickyPackage) {
      stickyPackage.addEventListener('change', function () {
        var nextPackage = packageCards.find(function (card) {
          return card.dataset.clPackageKey === stickyPackage.value;
        });
        if (!nextPackage || nextPackage.classList.contains('is-unavailable')) {
          updateSticky(0);
          return;
        }

        setSelectedPackage(nextPackage);
        updateSelectedVariant();
      });
    }

    if (stickyButton) {
      stickyButton.addEventListener('click', function () {
        if (form.requestSubmit) form.requestSubmit();
        else submitButton.click();
      });
    }

    if (sticky && submitButton && 'IntersectionObserver' in window) {
      var observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          sticky.classList.toggle('is-visible', !entry.isIntersecting);
        });
      }, { threshold: 0.05 });
      observer.observe(submitButton);
    }

    updatePackagePrices();
    updateSelectedVariant();
  }

  function initSelector(section) {
    if (section.dataset.clReady === 'true') return;
    section.dataset.clReady = 'true';

    var cards = Array.from(section.querySelectorAll('[data-cl-selector-card]'));
    if (!cards.length) return;

    var stage = section.querySelector('[data-cl-selector-stage]');
    var previous = section.querySelector('[data-cl-selector-previous]');
    var next = section.querySelector('[data-cl-selector-next]');
    var title = section.querySelector('[data-cl-selector-title]');
    var color = section.querySelector('[data-cl-selector-color]');
    var price = section.querySelector('[data-cl-selector-price]');
    var customize = section.querySelector('[data-cl-selector-customize]');
    var features = section.querySelector('[data-cl-selector-features]');
    var moneyFormat = section.dataset.clMoneyFormat || '${{amount}}';
    var productUrl = section.dataset.clProductUrl || '#';
    var activeIndex = 0;
    var isExpanded = false;
    var pointerStartX = null;
    var suppressClick = false;

    function circularOffset(index) {
      var offset = index - activeIndex;
      var half = cards.length / 2;
      if (offset > half) offset -= cards.length;
      if (offset < -half) offset += cards.length;
      return offset;
    }

    function update() {
      var activeCard = cards[activeIndex];
      cards.forEach(function (card, index) {
        var offset = circularOffset(index);
        var isActive = index === activeIndex;
        card.classList.toggle('is-active', isActive);
        card.classList.toggle('is-before', offset === -1);
        card.classList.toggle('is-after', offset === 1);
        card.classList.toggle('is-hidden', Math.abs(offset) > 1);
        card.setAttribute('aria-pressed', isActive ? 'true' : 'false');
        card.setAttribute('aria-expanded', isActive && isExpanded ? 'true' : 'false');

        var image = card.querySelector('img');
        if (image) {
          var source = isActive && isExpanded
            ? (card.dataset.clSelectorExpandedImage || card.dataset.clSelectorBaseImage)
            : card.dataset.clSelectorBaseImage;
          if (source && image.src !== source) image.src = source;
        }
      });

      stage.classList.toggle('is-expanded', isExpanded);
      if (features) features.hidden = !isExpanded;
      if (title) title.textContent = title.dataset.clDefaultTitle || title.textContent;
      if (color) color.textContent = activeCard.dataset.clSelectorLabel || '';
      if (price) {
        price.textContent = activeCard.dataset.clSelectorPrice
          ? formatMoney(activeCard.dataset.clSelectorPrice, moneyFormat)
          : '';
      }
      if (customize) {
        var variantId = activeCard.dataset.clSelectorVariantId;
        customize.href = variantId ? productUrl + (productUrl.indexOf('?') > -1 ? '&' : '?') + 'variant=' + variantId : productUrl;
        customize.classList.toggle('is-disabled', !variantId);
        customize.setAttribute('aria-disabled', variantId ? 'false' : 'true');
      }
    }

    function select(index) {
      activeIndex = (index + cards.length) % cards.length;
      isExpanded = false;
      update();
    }

    cards.forEach(function (card, index) {
      card.addEventListener('click', function (event) {
        if (suppressClick) {
          event.preventDefault();
          return;
        }
        if (index !== activeIndex) select(index);
        else {
          isExpanded = !isExpanded;
          update();
        }
      });
    });

    if (previous) previous.addEventListener('click', function () { select(activeIndex - 1); });
    if (next) next.addEventListener('click', function () { select(activeIndex + 1); });
    if (customize) {
      customize.addEventListener('click', function (event) {
        if (customize.getAttribute('aria-disabled') === 'true') event.preventDefault();
      });
    }

    if (stage) {
      stage.addEventListener('pointerdown', function (event) {
        pointerStartX = event.clientX;
      });
      stage.addEventListener('pointerup', function (event) {
        if (pointerStartX === null) return;
        var delta = event.clientX - pointerStartX;
        pointerStartX = null;
        if (Math.abs(delta) < 36) return;
        suppressClick = true;
        select(activeIndex + (delta < 0 ? 1 : -1));
        window.setTimeout(function () { suppressClick = false; }, 0);
      });
      stage.addEventListener('pointercancel', function () { pointerStartX = null; });
    }

    update();
  }

  function init(root) {
    initDismissibles(root);
    initGalleries(root);
    (root || document).querySelectorAll('[data-cl-product-section]').forEach(initProduct);
    (root || document).querySelectorAll('[data-cl-selector]').forEach(initSelector);
  }

  document.addEventListener('shopify:section:load', function (event) {
    init(event.target);
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(document); });
  } else {
    init(document);
  }
})();